import { App } from 'vue'
import Login from './app/layouts/Login.vue'
import Public from './app/layouts/Public.vue'
import Home from './app/layouts/Home.vue'
import {
  Home03Icon,
  Tool02Icon,
  Users01Icon,
  CalculatorIcon,
  File07Icon,
  Shield02Icon,
  PackageIcon,
  SearchLgIcon,
  PlusIcon,
  XIcon,
  Mail01Icon,
  User01Icon,
  CRIcon,
  CAIcon,
  COLIcon,
  DOIcon,
  HNIcon,
  MXIcon,
  NIIcon,
  PAIcon,
  PEIcon,
  UYIcon,
  UploadCloud01Icon,
  Certificate01Icon,
  Certificate02Icon
} from 'front-library'
export function registerGlobalComponents(app: App) {
  app
    .component('Home03Icon', Home03Icon)
    .component('Tool02Icon', Tool02Icon)
    .component('Users01Icon', Users01Icon)
    .component('CalculatorIcon', CalculatorIcon)
    .component('File07Icon', File07Icon)
    .component('Shield02Icon', Shield02Icon)
    .component('PackageIcon', PackageIcon)
    .component('SearchLgIcon', SearchLgIcon)
    .component('PlusIcon', PlusIcon)
    .component('XIcon', XIcon)
    .component('Mail01Icon', Mail01Icon)
    .component('User01Icon', User01Icon)
    .component('CRIcon', CRIcon)
    .component('CANIcon', CAIcon)
    .component('COIcon', COLIcon)
    .component('DOIcon', DOIcon)
    .component('HNIcon', HNIcon)
    .component('MXIcon', MXIcon)
    .component('NIIcon', NIIcon)
    .component('PAIcon', PAIcon)
    .component('PEIcon', PEIcon)
    .component('UYIcon', UYIcon)
    .component('UploadCloud', UploadCloud01Icon)
    .component('CertificateIcon1', Certificate01Icon)
    .component('CertificateIcon2', Certificate02Icon)
    .component('LoginLayout', Login)
    .component('PublicLayout', Public)
    .component('HomeLayout', Home)
}
